import React, { useState } from 'react'
import MyBonusHistory from './MyBonusHistory'
import BonusUsage from '../bonusUsage/BonusUsage';
import BackArrow from '../common/BackArrow';
import FreeGames from './FreeGames';

const MyBonuses = () => {
    const [tabType, setTabType] = useState('bonusHistory');

    return (
        <div className="SB-page-content">
            <div id="page-myAccountMenu" className="SB-myAccountSideMenu">
            </div>
            <div className="SB-myAccountSection-container SB-bonusHistory SB-bonususage">
                <div className="SB-pageHeader">
                    <div className="SB-pageBackButton">
                        <BackArrow />
                    </div>
                    <div className="SB-pageHeader-title">My Bonuses</div>
                </div>
                <div className="SB-myAccountSection-filters-container">
                    <div className="SB-tabs">
                        <ul className="nav">
                            <li>
                                <a className={`SB-tab-item nav-link ${tabType === "bonusHistory" ? "active" : ""}`} data-toggle="tab" onClick={() => setTabType('bonusHistory')}>
                                    Bonus History
                                </a>
                            </li>
                            <li className="">
                                <a className={`SB-tab-item nav-link ${tabType === "bonusUsage" ? "active" : ""}`} data-toggle="tab" onClick={() => setTabType('bonusUsage')}>
                                    Bonus Usage
                                </a>
                            </li>
                            <li className="">
                                <a className={`SB-tab-item nav-link ${tabType === "freeGames" ? "active" : ""}`} data-toggle="tab" onClick={() => setTabType('freeGames')}>
                                    Free Games
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="SB-tab-content">
                    <div className={`SB-tab-pane ${tabType === "bonusHistory" ? "active" : ""}`} id="SB-bonushistory">
                        <MyBonusHistory />
                    </div>
                    <div className={`SB-tab-pane ${tabType === "bonusUsage" ? "active" : ""}`} id="SB-bonususage">
                        <BonusUsage tabType={tabType} />
                    </div>
                    <div className={`SB-tab-pane ${tabType === "freeGames" ? "active" : ""}`} id="SB-freegames">
                        <FreeGames />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MyBonuses